import { render, staticRenderFns } from "./TransferTaskDialogueSubOwner.vue?vue&type=template&id=040e369d&scoped=true"
import script from "./TransferTaskDialogueSubOwner.vue?vue&type=script&lang=js"
export * from "./TransferTaskDialogueSubOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e369d",
  null
  
)

export default component.exports